import { memo } from "react";
import styled from "styled-components";

const StyledButton = styled.button`
  font-size: 16px;
  font-weight: normal;
  color: #ffffff;
  background-color: #ff9800;
  padding: 15px;
  margin: 0px;
  border-radius: 5px;
  border: 0px;
  cursor: pointer;
  outline: 0px;
  min-width: 200px;
  transition: background-color 0.5s ease;
  &:hover {
    background-color: #d88100;
    transition: background-color 0.5s ease;
  }
  &:disabled {
    background-color: #cfcfcf;
    color: #9a9a9a;
    cursor: not-allowed;
  }
`;

const Button = memo(({ children, disabled, ...rest }) => (
  <StyledButton {...rest} disabled={disabled}>
    {children}
  </StyledButton>
));

export default Button;
